import { TSummaryCardProps } from '@cian/frontend-e2e-deal-component';

import { transformNumToString } from '../../common/utils';
import { PROGRAM_LABELS, REAL_ESTATE_TYPE_LABELS } from '../constants';
import { IApplicationOffers, IApplicationSearchParams } from '../types';

const formatMoney = (value: number): string => `${new Intl.NumberFormat('ru-RU').format(value)} ₽`;

interface IMapApplicationToSummaryCardOptions {
  offers: IApplicationOffers | null;
  searchParams: IApplicationSearchParams | null;
}

export const mapApplicationToSummaryCard = ({
  offers,
  searchParams,
}: IMapApplicationToSummaryCardOptions): TSummaryCardProps | undefined => {
  if (!offers) {
    return undefined;
  }

  const bullets = [
    searchParams?.realEstateType ? REAL_ESTATE_TYPE_LABELS[searchParams.realEstateType] : undefined,
    searchParams?.benefitProgram ? PROGRAM_LABELS[searchParams.benefitProgram] : undefined,
  ];

  const terms = [
    searchParams ? { name: 'Стоимость', value: formatMoney(searchParams.objectCost) } : undefined,
    searchParams ? { name: 'Первый взнос', value: formatMoney(searchParams.downPayment) } : undefined,
    { name: 'Ставка', value: `От ${transformNumToString(offers.minRate)}%` },
    searchParams ? { name: 'Срок', value: `${searchParams.loanTermYears} лет` } : undefined,
  ];

  return {
    title: `От ${formatMoney(offers.minMonthlyPayment)}/мес`,
    subtitleBullets: bullets.filter((bullet): bullet is string => Boolean(bullet)),
    logos: offers.banksLogosPaths,
    terms: terms.filter((term): term is { name: string; value: string } => Boolean(term)),
  };
};
